export default "__VITE_ASSET__DSxr_6b4__"